export const SET_USER_TOKEN = 'auth/SET_USER_TOKEN'
export const SET_USER_REFRESH_TOKEN = 'auth/SET_USER_REFRESH_TOKEN'
export const SET_USER_LOGGED_DATA = 'auth/SET_USER_LOGGED_DATA'
